var Request = require("../helper/request");

function Advertisement(app, userId){
	var self = this;
	self.userId = userId;
	self.request = new Request(app);

	self.routes = {
		index: {
			url: "/iam/user/"+self.userId+"/advertisement",
			method: "GET"
		}
	};
}

Advertisement.prototype.index = function(){
	var self = this;
	return self.request.get(self.routes.index.url);
}

module.exports = Advertisement;